<div class="absolute bg-white shadow-lg p-4 rounded-lg border border-gray-300 min-w-72 max-h-96 overflow-auto">
  <a (click)="close($event)" id="popup-closer" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 cursor-pointer text-lg">✖</a>
  <div id="popup-content" class="mt-2">
    <table class="w-full">
      <thead>
        <tr class="border-b border-gray-200">
          <th class="text-left py-2 px-2 font-medium text-gray-900">Attribute</th>
          <th class="text-left py-2 px-2 font-medium text-gray-900">Value</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of attributes; index as i" class="border-b border-gray-100">
          <td class="py-2 px-2 text-gray-700">{{row.attribute}}</td>
          <td class="py-2 px-2 text-gray-700">{{row.value}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
